var React = require('react');

function IconStarCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Paths"},[React.createElement("circle",{"id":"Ellipse 36","cx":"12","cy":"12","r":"10.8","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Star 1","d":"M12 5.3999L13.8621 9.43694L18.277 9.96039L15.013 12.9789L15.8794 17.3394L12 15.1679L8.12064 17.3394L8.98708 12.9789L5.72305 9.96039L10.1379 9.43694L12 5.3999Z","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

IconStarCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconStarCircle;

IconStarCircle.default = IconStarCircle;
